import { Button, Text } from '@mantine/core';
import { IconPointFilled } from '@tabler/icons-react';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { DirtyHint, PersistentFooter } from './bindPanel.styled.ts';

interface Props {
	isDirty: boolean;
	isSaving: boolean;
	onSave: () => void;
	onDiscard: () => void;
}

/**
 * The side column's save bar. It lives outside {@link BindPanel} so that
 * deleting the last field — or simply deselecting — can't take Save off screen
 * with the panel.
 */
export const BindPanelFooter = ({ isDirty, isSaving, onSave, onDiscard }: Props) => {
	const tMipManage = useTranslationMipManage();

	return (
		<PersistentFooter data-testid="bind-panel-footer">
			<DirtyHint $isDirty={isDirty}>
				{isDirty && <IconPointFilled size={14} />}
				<Text size="xs" c={isDirty ? 'orange.7' : 'dark.0'}>
					{tMipManage(
						isDirty
							? 'master_documents.field_binding.footer.unsaved'
							: 'master_documents.field_binding.footer.all_saved'
					)}
				</Text>
			</DirtyHint>
			<Button
				variant="subtle"
				color="gray"
				onClick={onDiscard}
				disabled={!isDirty || isSaving}
			>
				{tMipManage('master_documents.field_binding.footer.discard')}
			</Button>
			<Button onClick={onSave} disabled={!isDirty || isSaving} loading={isSaving}>
				{tMipManage('master_documents.field_binding.panel.save')}
			</Button>
		</PersistentFooter>
	);
};
